<template>
  <div @click="$emit('click', idx)" @mouseover="handleMouseover" @mouseleave="handleMouseLeave">
    <div
      :class="hover ? 'hover-theme' : ''"
      class="theme-color"
      data-testid="theme-color-cy"
      :style="`background-color: ${backgroundColor}`"
    ></div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        hover: false,
      };
    },
    props: {
      backgroundColor: {
        type: String,
      },
      idx: {
        type: Number,
      },
    },
    methods: {
      handleMouseover() {
        this.hover = true;
      },
      handleMouseLeave() {
        this.hover = false;
      },
    },
  };
</script>
